<!--//Created by keni.-->
<!--//User: keni-->
<!--//Date: 14/02/2018-->
<!--//Time: 14:06-->

<template>
    <section class="graph-list--module">
        <div class="">
            <div class=" d-flex justify-content-between align-items-top ">
                <div v-on:click="show_graph = !show_graph"
                        class="cursor-pointer"
                >
                    <div class="d-inline-block the-title" v-html="settings.title"></div>
                    <div class="d-inline-block dashboard-module-small--value ml-2">
                        {{currency}}{{settings.sale_total}}
                    </div>
                </div>
                <actions-menu-module
                        @click_events="actionEventHandler"
                        :download="{
                    name: settings.file_name + '.' + exportData.type,
                    type: exportData.type,
                    fields: exportData.json_fields,
                    data: sale_records
                }"
                >
                </actions-menu-module>
            </div>
        </div>

        <transition
                name="accordionShowDown"
                v-on:before-enter="beforeEnter"
                v-on:enter="enter"
                v-on:after-enter="afterEnter"
                v-on:enter-cancelled="enterCancelled"

                v-on:before-leave="beforeLeave"
                v-on:leave="leave"
                v-on:after-leave="displayGraphAfterLeave"
                v-on:leave-cancelled="leaveCancelled"
        >
            <div :id="chartWrapper.id"
                    class="chartWrapper" :class="[{
        'chartWrapper--scrollable':chartOptions.responsive == false
        },chartWrapper.class]"
                    v-if="sale_records.length && show_graph==true"
            >
                <line-chart
                        :chart-wrapper="chartWrapper"
                        :chart-id="chartId"
                        :width="chartWidth"
                        :height="chartHeight"
                        :styles="chartCanvasWrapperStyle"
                        :css-classes="chartCanvasWrapper.classes"
                        :options="chartOptions"
                        :chart-data="chartData"
                        :reloadChart="reloadChart"
                        @line_chart_loaded="childLoaded"
                ></line-chart>
            </div>
        </transition>
        <sales-list
                :laravel_route_uri="laravel_route_uri"
                :sale_route_name="sale_route_name"
                :records="sale_records"
                @sales_list_loaded="childLoaded"
        ></sales-list>
    </section>
</template>

<script>
	import {_} from 'underscore';
	import debounce from 'debounce';

	import {SalesComponent} from './SalesComponent';

	import {uniqueId, uniqueClass} from "../../../../../app/Shared/Resources/Assets/js/helpers/classesAndIds";
	import {format as formatMoney} from "../../../../../app/Shared/Resources/Assets/js/helpers/money";
	import {getDate, DATE_FORMAT} from "../../../../../app/Shared/Resources/Assets/js/helpers/format.date";

	Vue.component('actions-menu-module', require('./ActionsMenuModule'));
	Vue.component('sales-list', require('../lists/SalesList.vue'));
	Vue.component('line-chart', require('../charts/LineChart.vue'));
	export default {
		name: "graph-list-module",
		components: {},
		// props: ['window_width', 'set_responsive','parameters','items'],
		props: {
			/**
			 * @namespace
			 * @property {string}  parameters.data_type
			 * @property {string}  parameters.filter_date
			 * @property {string}  parameters.type
			 */
			parameters: Object,
			request_route_uri: String,
			laravel_route_uri: String,
			sale_route_name: String,

			window_width: Number,
			set_responsive: Boolean,
			load_items: Boolean,
			filter_date: String,
		},
		updated() {
		},
		created() {
		},
		beforeDestroy() {
			// window.removeEventListener('resize', this.getBreakPoint);
		},
		destroyed() {
		},
		mounted() {
			this.chartWrapper.chartHeight = this.chartHeight;
			this.chartWrapper.class = uniqueClass('chart-wrapper');
			this.chartWrapper.areaClass = this.chartWrapper.class + this.chartWrapper.areaClassAppend;

			// create the list of classes for the wrapper
			this.chartCanvasWrapper.classesRaw.push(this.chartWrapper.areaClass);

			// console.log('this.chartCanvasWrapper.classesRaw', this.chartCanvasWrapper.classesRaw);

			this.chartCanvasWrapper.classes = this.chartCanvasWrapper.classesRaw.join(' ');
			// this.createRandomData();
			// console.log('this.chartWrapper', this.chartWrapper);
			this.local_filter_date = this.parameters.filter_date;

			this.$nextTick(function () {
				this.report();
				window.addEventListener('resize', debounce(this.getBreakPoint, 200));

				//Init
				this.getBreakPoint();

			});
		},
		data() {
			return {
				/**
				 * @namespace parameters
				 * @property index
				 */
				items: Array,
				local_filter_date: String, //stores date selected from calendar
				date_range: Object,
				show_graph: true,
				currency: '£',
				fully_loaded: 0,
				reloadChart: true,
				setDevTester: false,
				chartOptions: {
					title: {
						display: false,
						text: ''
					},
					responsive: false,
					maintainAspectRatio: false,
				},
				chartData: {
					labels: [],
					datasets: [
						{
							label: 'sales',
							backgroundColor: this.createDataSetColors('sales', 'background-color'),
							borderColor: this.createDataSetColors('sales', 'border-color'),
							hoverBackgroundColor: this.createDataSetColors('sales', 'background-color'),
							hoverBorderColor: this.createDataSetColors('sales', 'border-color'),
							borderWidth: 1,
							data: []
						},
						{
							label: 'count',
							backgroundColor: this.createDataSetColors('count', 'background-color'),
							borderColor: this.createDataSetColors('count', 'border-color'),
							hoverBackgroundColor: this.createDataSetColors('count', 'background-color'),
							hoverBorderColor: this.createDataSetColors('count', 'border-color'),
							borderWidth: 1,
							data: []
						}
					]
				},
				chartId: uniqueId('chartId'),
				chartWrapper: {
					areaClass: '',
					areaClassAppend: '--area',
					class: '',
					id: uniqueId('chart-wrapper'),
					chartHeight: 0
				},

				fullWidthGrid: ['xs', 'sm', 'md'],
				mediaBreakPoint: '',
				defaultWidth: 600,
				maxChartWidth: 800,
				chartCanvasWrapper: {
					classesRaw: ['chartCanvasWrapper', 'chartAreaWrapper'],
					classes: ''
				},
				chartCanvasWrapperWidth: 0,
				chartWidth: 600, //chart width
				chartHeight: 200,//chart height
				cssClasses: '',//String with css classes for the surrounding div
				chartCanvasWrapperStyle: {
					// backgroundColor: '#1d3963',
					width: '400px',
					overflowX: 'scroll'
				},
				chartCanvasWrapperStyleDefault: {
					// backgroundColor: '#015063',
					width: '100%',
				},
				settings: {
					chart_data: []
				},
				sale_records: [],
				exportData: {
					type: 'csv',
					json_fields: {
						'Complete name': 'name',
						'City': 'city',
						'Telephone': 'phone.mobile',
						'Telephone 2': {
							field: 'phone.landline',
							callback: (value) => {
								return `Landline Phone - ${value}`;
							}
						},
					},
					json_data: [
						{
							'name': 'Tony Peña',
							'city': 'New York',
							'country': 'United States',
							'birthdate': '1978-03-15',
							'phone': {
								'mobile': '1-541-754-3010',
								'landline': '(541) 754-3010'
							}
						},
						{
							'name': 'Thessaloniki',
							'city': 'Athens',
							'country': 'Greece',
							'birthdate': '1987-11-23',
							'phone': {
								'mobile': '+1 855 275 5071',
								'landline': '(2741) 2621-244'
							}
						}
					],
					json_meta: [
						[
							{
								'key': 'charset',
								'value': 'utf-8'
							}
						]
					],
				},
			}
		},
		methods: {
			createDataSetColors(id, elmType) {
				let elm = document.getElementById('dummy-support--dashboards--' + id);

				// console.log('readBodyColor', 'elm', elm);

				let css = window.getComputedStyle(elm);

				// console.log('createDataSetColors', 'css',css);
				return css[elmType];
			},
			report() {
				// console.log(this,'this.parameters',this.parameters);
				let test = getDate(this.local_filter_date, 'data_base');
				// console.log('report', 'test',test,'this.local_filter_date',this.local_filter_date);
				let _this = this,
					data = {
						module_type: _this.parameters.type,
						type: _this.parameters.data_type,
						frequency: _this.parameters.frequency,
						filter_date: getDate(_this.local_filter_date, 'data_base'),
					};

				// console.log('read() data', data);
				return axios.post(this.request_route_uri, data)
					.then(function (response) {
						// console.log('response.data', response.data);
						if (response.data.success) {
							_this.items = response.data.sales;
							_this.date_range = response.data.date;
							_this.loadingDataSet = false;
							_this.itemsChanged();
						}
						// console.log('_this.dashboards', _this.dashboards);
						return _this;
					})
					.catch(function (e) {
						console.error('e', e);
					});
			},

			displayGraphAfterLeave: function (el) {
				console.log('displayGraphAfterLeave', 'layout_changed');
				this.$emit('layout_changed');
			},
			// leaveCancelled only available with v-show
			leaveCancelled: function (el) {
				console.log('leaveCancelled');
			},
			actionEventHandler(obj) {
				// console.log('actionEventHandler',obj);
				switch (obj.action) {
					case 'download':

						break;
					case 'calendar':
						this.openCalendar();
						break;
				}

			},
			openCalendar() {
				// console.log('this.parameters', this.parameters);
				// this.dateChooser.display = !this.dateChooser.display;
				// console.log('this.dateChooser',this.dateChooser);
				this.$emit('open_calendar', {
					index: this.parameters.index
				});
				this.settings.chart_data = [];

			},
			/**
			 * Set the local_filter_date and rerun request
			 * @param value
			 * @returns {*}
			 */
			reloadWithRange(value) {

				this.local_filter_date = (value.trim() == '') ? new Date() : new Date(value);
				// console.log('reloadWithRange', 'this.local_filter_date',this.local_filter_date,'value',typeof value,new Date(value));
				return this.report();
			},
			loadChart(items, settings) {
				let _this = this,
					_settings = settings;

				// console.log('settings', _settings);
				try {
					if ((typeof items !== 'undefined' && items !== null) || (typeof _settings !== 'undefined' && _settings !== null)) {

						_settings = this.salesComponent._setDateRangeRaw(_settings, _this.date_range);

						this.settings.sale_records = [];
						this.settings = this.salesComponent.setChartData(items, _settings);

						// console.log('loadChart()', this.settings);
						let salesData = [],
							salesCount = [];

						// console.log('this.settings.chart_labels', this.settings.chart_labels);
						for (let i = 0; i < this.settings.chart_data.length; i++) {
							let chartDatum = this.settings.chart_data[i];
							let sale = chartDatum.sales;
							// console.log('formatMoney(sale * 100)',formatMoney(sale * 100));
							salesData.push(sale);
							salesCount.push(chartDatum.count);
						}

						this.chartData.datasets[0].data = salesData;
						this.chartData.datasets[1].data = salesCount;

						if (salesCount.length > 0) {
							this.chartData.labels = this.settings.chart_labels;
						}
						this.sale_records = [];
						// this.compileSalesList();
						let compiledSales = this.salesComponent.compileSalesList(this.settings.sale_records, this.parameters.export_schema);

						if (typeof compiledSales.json_data !== 'undefined' && compiledSales.json_data !== null) {
							this.sale_records = compiledSales.json_data;
						}
						else {
							this.sale_records = [];
						}
						this.exportData.json_fields = compiledSales.json_fields;
						this.reloadView();
						this.$emit('layout_changed');
					}
					else {
						throw new Error('items undefined');
					}
				} catch (e) {
					console.error(e);
				}

				return this;

			},
			childLoaded() {
				this.fully_loaded = ++this.fully_loaded;
				this.$emit('layout_changed');
				// console.log('this.fully_loaded', this.fully_loaded);
				if (this.fully_loaded == 2) {
					this.$emit('child_loaded', 'graph-list-module');
				}
			},
			reloadView() {
				this.reloadChart = !this.reloadChart;
			},
			getScroll() {
				let inner = document.createElement('p'),
					outer = document.createElement('div');

				/**
				 * Set inner properties
				 * @type {string}
				 */
				inner.style.width = "100%";
				inner.style.height = "200px";

				/**
				 * Set outer properties
				 * @type {string}
				 */
				outer.style.position = "absolute";
				outer.style.top = "0px";
				outer.style.left = "0px";
				outer.style.visibility = "hidden";
				outer.style.width = "200px";
				outer.style.height = "150px";
				outer.style.overflow = "hidden";
				outer.appendChild(inner);

				document.body.appendChild(outer);
				let w1 = inner.offsetWidth;

				outer.style.overflow = 'scroll';
				let w2 = inner.offsetWidth;

				if (w1 == w2) {
					w2 = outer.clientWidth;
				}

				document.body.removeChild(outer);

				return (w1 - w2);
			},
			fillData() {
				let _this = this,
					randomIndex = _.random(0, 11),
					value = _this.itemsData[randomIndex] + _.random(1, 3);

				Vue.set(this.itemsData, randomIndex, parseInt(value));
			},
			getViewportDimensions() {

			},
			getParentWidth() {
				let element = document.getElementsByClassName('graph-list--module')[0];
				return element.clientWidth;
			},
			reafactorWidths() {
				this.defaultWidth = 0;
				this.maxChartWidth = 0;
				this.chartWidth = 0;
				this.chartCanvasWrapperStyle.width = 0 + 'px';
			},
			/**
			 * Prepares params from making the chart scroll horizontally
			 */
			setWidthToScroll() {
				// on mobile view
				// chart will be full screen but scrollable

				// let element = document.getElementsByTagName('body')[0];
				this.chartCanvasWrapperWidth = this.getParentWidth();
				let scrollBarWidth = this.getScroll();

				// console.log('scrollBarWidth', scrollBarWidth, 'chartCanvasWrapperWidth', this.chartCanvasWrapperWidth);
				//update the style prop for the wrapper
				this.chartCanvasWrapperStyle = {
					// backgroundColor: 'red',
					width: this.chartCanvasWrapperWidth + 'px',
					overflowX: 'scroll'
				};
				this.chartWidth = 800;
				// this.chartWidth = this.maxChartWidth;
			},
			getBreakPoint() {

				let setResponsive = false,
					elementInViewport = $('#media-break-points').find('div:visible').data('break-point');

				if (this.set_responsive) {
					console.error('call to override chart via props and force responsive');

				}
				else {
					/**
					 * Prevent multiple calls
					 */
					// if (elementInViewport && this.mediaBreakPoint != elementInViewport) {
					this.mediaBreakPoint = elementInViewport;

					// is the current view to e stacked?
					if (this.fullWidthGrid.indexOf(this.mediaBreakPoint) >= 0) { // break point is found
						this.setWidthToScroll(this.mediaBreakPoint);
						setResponsive = false;
					}
					else {
						// grid fits into surrounding div
						// no breakpoint to e stacked so set the default width of the chart or make it fit 100%
						this.chartCanvasWrapperStyle = this.chartCanvasWrapperStyleDefault;
						setResponsive = true;

					}
				}
				// console.warn('setResponsive', setResponsive);
				Vue.set(this.chartOptions, 'responsive', setResponsive);
				// }
			},
			itemsChanged() {
				this.salesComponent = new SalesComponent(this.parameters, 'chart');
				this.loadChart(this.items, this.settings);
			},
			/*********************** events ****************************/
			beforeEnter: function (el) {
				// console.log('beforeEnter');
			},
			// the done callback is optional when
			// used in combination with CSS
			enter: function (el, done) {
				// console.log('enter');
				done()
			},
			afterEnter: function (el) {
				// this.$emit('layout_changed');
			},
			enterCancelled: function (el) {
				// console.log('enterCancelled');
			},
			// --------
			// LEAVING
			// --------
			beforeLeave: function (el) {
				// console.log('beforeLeave');
			},
			// the done callback is optional when
			// used in combination with CSS
			leave: function (el, done) {
				// console.log('leave');
				done()
			},
		},
		computed: {},
		watch: {
			chartWidth(val, old) {
				// console.log(val, old);
			},
			// parameters(params) {
			// 	console.log('params', params);
			// },
			// load_items(){
			// this.itemsChanged(this.items);
			// },

			// items(items) {
			// 	console.log('items changed', items);
			// 	this.itemsChanged(items);
			// },
			/**
			 * On update of record, compiled the values for prop passing
			 * @param date
			 */
			filter_date(date) {
				// console.log('date', date);
				this.settings.chart_data = [];

				this.reloadWithRange(date);
				this.$emit('layout_changed');
			},
		}
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/modules/GraphListModule.vue?c67b32c2